import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const CreditsContext = createContext(null);

export const CreditsProvider = ({ children }) => {
  const { user } = useAuth();
  const [credits, setCredits] = useState(null);
  const [models, setModels] = useState([]);
  const [pricing, setPricing] = useState({ plan: 1, images: 6 });

  const refresh = useCallback(async () => {
    if (!localStorage.getItem("ishukart_token")) return setCredits(null);
    try { setCredits(await api.credits()); } catch { /* ignore */ }
  }, []);

  useEffect(() => { refresh(); }, [user, refresh]);
  useEffect(() => {
    api.models().then((r) => { setModels(r.models); setPricing({ plan: r.plan_credits, images: r.ai_image_credits, lowAt: r.low_balance_credits }); }).catch(() => {});
  }, []);

  const costOf = useCallback((model, plan, aiImages) => {
    if (plan) return pricing.plan;
    const base = models.find((m) => m.id === model)?.credits;
    return base == null ? null : base + (aiImages ? pricing.images : 0);
  }, [models, pricing]);

  return (
    <CreditsContext.Provider value={{ credits, refresh, setCredits, models, pricing, costOf }}>
      {children}
    </CreditsContext.Provider>
  );
};

export const useCredits = () => useContext(CreditsContext);
